// src/pages/Login.tsx
import { useEffect } from 'react';
import { signInWithRedirect } from 'aws-amplify/auth';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const Login = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    const initiateSignIn = async () => {
      if (!loading && !user) {
        // Redirect to localhost if currently on 127.0.0.1
        if (window.location.hostname === '127.0.0.1') {
          const newUrl = window.location.href.replace(
            '127.0.0.1',
            'localhost'
          );
          window.location.replace(newUrl);
          return;
        }

        await signInWithRedirect();
      }
    };

    initiateSignIn();
  }, [loading, user]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (user) {
    navigate('/dashboard', { replace: true });
    return null;
  }

  return null;
};

export default Login;
